import { useEffect, useState } from "react";
import { MachinesByGroup } from "../../Types/dashboardTypes";
import Dropdown from "../Dropdown/Dropdown";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

import "../Dropdown/Dropdown.less";

interface Props {
  machinesByGroup: MachinesByGroup[];
  currentMachineIndex: number;
  setCurrentMachineIndex: React.Dispatch<React.SetStateAction<number>>;
  isArrows?: boolean;
  isPaddingTop?: boolean;
}

const MachineSelector: React.FC<Props> = (props) => {
  const { machinesByGroup, currentMachineIndex, setCurrentMachineIndex, isArrows = true, isPaddingTop = false } = props;
  const [machineList, setMachineList] = useState<string[]>([]);

  useEffect(() => {
    const names: string[] = [];
    machinesByGroup.map((value) => {
      names.push(value.machineSerial);
    });
    setMachineList(names);
  }, [machinesByGroup]);

  const onBackForward = (direction: string) => {
    const maxIndex = machineList.length - 1;
    if (direction == "right") {
      setCurrentMachineIndex((currentMachineIndex) => (maxIndex > currentMachineIndex ? currentMachineIndex + 1 : 0));
    } else if (direction == "left") {
      setCurrentMachineIndex((currentMachineIndex) =>
        currentMachineIndex - 1 < 0 ? maxIndex : currentMachineIndex - 1
      );
    }
  };

  function handleChange(e: string) {
    setCurrentMachineIndex(machineList.indexOf(e));
  }

  return (
    <div style={{ paddingTop: isPaddingTop ? "14px" : "0px" }} className="machine-selector-dropdown-main-div">
      {isArrows && (
        <button
          disabled={machinesByGroup.length == 0}
          className="icon-button left"
          onClick={() => onBackForward("left")}
        >
          <LeftOutlined />
        </button>
      )}
      <Dropdown
        options={machinesByGroup.map((e) => ({
          label: e.machineName,
          value: e.machineSerial,
        }))}
        isShowSearch={true}
        isShowArrow={false}
        value={machineList[currentMachineIndex]}
        onChange={(value) => handleChange(value as string)}
        mainClassName={"machine-selector-dropdown"}
        notFoundContent={null}
      />
      {isArrows && (
        <button
          disabled={machinesByGroup.length == 0}
          className="icon-button right"
          onClick={() => onBackForward("right")}
        >
          <RightOutlined />
        </button>
      )}
    </div>
  );
};

export default MachineSelector;
